<template>
    <!--item -->
    <div class="item mt-2">
        <div class="avatar">
            <ion-icon size="large" :name="item.isRead ? 'mail-open-outline' : 'mail-outline'"></ion-icon>
        </div>

        <div class="in">
            <div class="comment-header">
                <h4 class="title">{{ item.isRead ? 'خوانده شد' : 'جدید' }}</h4>
                <span class="time">{{ item.persianDate }}</span>
            </div>
            <div class="text">
                {{ item.description }}
            </div>
            <div class="comment-footer" v-show="!item.isRead">
                <a href="#" class="comment-button" @click="deleteItem()">
                    <ion-icon name="trash-outline"></ion-icon>
                    خذف شود؟
                </a>

            </div>
        </div>
    </div>
    <!-- * item -->
</template>
<script>
export default {
    name: 'NotificationBox',
    props: ['item'],
    methods: {
        deleteItem(){
            this.$emit('toggle-read', this.item.id);
        }
    },
}
</script>
<style></style>